import CardsCarousel from './CardsCarousel'

export default CardsCarousel
